import { defineStore } from 'pinia'
import DeviceMeasurementsState, { DeviceMeasurementsStateType } from './state'
import { DeviceMeasurementsActions, DeviceMeasurementsActionsType } from './actions'
import { DeviceMeasurementsGetters } from './getters'

export const useDeviceMeasurementsStore = defineStore<
  'deviceMeasurements',
  DeviceMeasurementsStateType,
  typeof DeviceMeasurementsGetters,
  DeviceMeasurementsActionsType
>('deviceMeasurements', {
  state: DeviceMeasurementsState,
  actions: DeviceMeasurementsActions,
  getters: DeviceMeasurementsGetters,
})
